import React from 'react';
import canon from "../img/BrandsLogo/canon.svg";
import nikon from "../img/BrandsLogo/nikon.svg";
import sony from "../img/BrandsLogo/sony.svg";
import godox from "../img/BrandsLogo/godox.svg";

const BrandsParallax = () => {
  const brands = [
    { id: 1, name: 'Canon', logo: canon },
    { id: 2, name: 'Nikon', logo: nikon },
    { id: 3, name: 'Sony', logo: sony },
    { id: 4, name: 'Godox', logo: godox },
  ];

  const duplicatedBrands = [...brands, ...brands, ...brands];

  return (
    <section className="relative py-24  overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-purple-600/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-blue-600/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center mb-16">
        <span className="inline-block px-4 py-2 bg-purple-700/20 text-purple-300 text-sm font-medium rounded-full">
          Наши партнеры
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-2">
          Работаем с лидерами индустрии
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto">
          Сотрудничаем с лучшими мировыми брендами фототехники
        </p>
      </div>

      <div className="relative group overflow-hidden">
        <div className="flex gap-8 animate-scroll-right">
          {duplicatedBrands.map((brand, index) => (
            <div key={index} className="flex-shrink-0 w-72 h-40 py-4">
              <div className="flex h-full px-2 bg-white items-center justify-center rounded-2xl border border-gray-700 hover:border-purple-500 transition-all duration-300 hover:scale-105 shadow-sm hover:shadow-lg cursor-pointer">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="max-h-24 object-contain  transition duration-500"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-900 to-transparent pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-900 to-transparent pointer-events-none"></div>
      </div>

      <style>{`
        @keyframes scroll-right {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .animate-scroll-right {
          animation: scroll-right 40s linear infinite;
        }
        .animate-scroll-right:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default BrandsParallax;
